import type { GalleriaDesignTokens, GalleriaTokenSections } from '@openng/optimus-ui-themes/types/galleria';

export const navButton: GalleriaTokenSections.NavButton = {
	prev: {
		borderRadius: '{galleria.nav.button.size} / 2',
	},
	next: {
		borderRadius: '{galleria.nav.button.size} / 2',
	},
};

export const indicatorButton: GalleriaTokenSections.IndicatorButton = {
	borderRadius: '{galleria.indicator.button.width} / 2',
};

export const closeButton: GalleriaTokenSections.CloseButton = {
	borderRadius: '{galleria.close.button.size} / 2',
};

export default {
	navButton,
	indicatorButton,
	closeButton,
} satisfies GalleriaDesignTokens;
